export const useConfiguration = () => {
  const config = useRuntimeConfig()
  const JWP_PROJECT_ID: string = config.public.jwpProjectId

  return {
    JWP_PROJECT_ID
  }
}
